import { render, staticRenderFns } from "./responseDataTable.vue?vue&type=template&id=be536cf4&scoped=true"
import script from "./responseDataTable.vue?vue&type=script&lang=ts"
export * from "./responseDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be536cf4",
  null
  
)

export default component.exports